export enum LocalizationId {
    ConcurrencyErrorText = "shared-messages.toast.concurrency_session",

    InternalServerErrorToastTitle = "shared-messages.toast.api_internal_server_error_title",
    InternalServerErrorToastBody = "shared-messages.toast.api_internal_server_error_body",

    UnauthorizedErrorToastTitle = "shared-messages.toast.api_unauthorized_error_title",
    UnauthorizedErrorToastBody = "shared-messages.toast.api_unauthorized_error_body",
}
